import React from 'react'
import PropTypes from 'prop-types'

import TimeFormatter from 'infra/TimeFormatter'

export default class TimeAllocationTableSummary extends React.Component {

  static propTypes = {
    payrollInfo: PropTypes.array,
    dayTotals: PropTypes.array
  }

  constructor(props) {
    super(props)
    this.state = {
      payrollInfo: props.payrollInfo,
      dayTotals: props.dayTotals
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      payrollInfo: nextProps.payrollInfo,
      dayTotals: nextProps.dayTotals
    })
  }

  renderDays(values, isRatio) {
    const views = []
    for (let i = 0; i < values.length; i++) {
      const time = values[i]

      let timeStr = isRatio
        ? (isNaN(time) || time === 0 ? null : (time.toFixed(1) + '%'))
        : TimeFormatter.toHoursMinutesFormat(time)

      let fontColor = 'black'
      if (isRatio && (isNaN(time) || time < 100)) {
        fontColor = '#bf6565'
      }

      views.push(
        <div
          key={i}
          style={{ display: 'flex', flexGrow: 0, flexShrink: 0,
            justifyContent: 'center', alignItems: 'center', width: '80px',
            borderRight: '1px solid #e4e7ea' }}>
          <span
            style={{ fontSize: 14, color: fontColor }}>
            {timeStr}
          </span>
        </div>
      )
    }

    return views
  }

  renderNameText(text, width) {
    return (
      <div
        key={text}
        style={{ display: 'flex', justifyContent: 'flex-end',
          flexShrink: 0, alignItems: 'center',
          paddingLeft: 16, paddingRight: 16, width: width }}>
        <span
          style={{ fontSize: 14 }}>
          {text}
        </span>
      </div>
    )
  }

  renderTotalText(totalTime, isRatio) {
    // Convert time to String
    let timeStr = isRatio
      ? (isNaN(totalTime) ? '0%' : (totalTime.toFixed(1) + '%'))
      : TimeFormatter.toHoursMinutesFormat(totalTime)

    let fontColor = 'black'
    if (isRatio && (isNaN(totalTime) || totalTime < 100)) {
      fontColor = '#bf6565'
    }

    return (
      <div
        key={'total'}
        style={{ display: 'flex', flexGrow: 1, minWidth: 64,
          alignItems: 'center', justifyContent: 'flex-end', paddingLeft: 16,
          paddingRight: 16 }}>
        <span
          style={{ fontSize: 14, color: fontColor }}>
          {timeStr}
        </span>
      </div>
    )
  }

  renderDayTotals() {
    const total = this.state.dayTotals.length === 0
      ? 0 : this.state.dayTotals.reduce((a,b) => a+b)

    return (
      <div
        style={{ display: 'flex', flexDirection: 'row', height: '48px' }}>

        {this.renderNameText('Total', 288)}

        <div
          style={{ display: 'flex', flexDirection: 'row', flexGrow: 1,
            border: '1px solid #e4e7ea', borderTopWidth: 3, backgroundColor: '#fafbfc' }}>

          {this.renderDays(this.state.dayTotals)}
          {this.renderTotalText(total)}
        </div>
      </div>
    )
  }

  renderPayroll() {
    const total = this.state.payrollInfo.length === 0
      ? 0 : this.state.payrollInfo.reduce((a,b) => a+b)

    return (
      <div
        style={{ display: 'flex', flexDirection: 'row', height: '48px' }}>

        {this.renderNameText('Payroll Hours', 288)}

        <div
          style={{ display: 'flex', flexDirection: 'row', flexGrow: 1,
            border: '1px solid #e4e7ea', borderTopWidth: 0, backgroundColor: '#fafbfc' }}>
          {this.renderDays(this.state.payrollInfo)}
          {this.renderTotalText(total)}
        </div>
      </div>
    )
  }

  renderRatio() {
    const dayTotal = this.state.dayTotals.length === 0
      ? 0 : this.state.dayTotals.reduce((a,b) => a+b)
    const payrollTotal = this.state.payrollInfo.length === 0
      ? 0 : this.state.payrollInfo.reduce((a,b) => a+b)
    const ratioTotal = payrollTotal === 0 ? 0 : (100 * dayTotal / payrollTotal)

    const ratioInfo = this.state.payrollInfo.map(
      (value, index) => {
        if (this.state.payrollInfo[index] === 0) {
          return 0
        }
        return 100 * this.state.dayTotals[index] / this.state.payrollInfo[index]
      }
    )

    return (
      <div
        style={{ display: 'flex', flexDirection: 'row', height: '48px' }}>

        {this.renderNameText('Ratio', 288)}

        <div
          style={{ display: 'flex', flexDirection: 'row', flexGrow: 1,
            border: '1px solid #e4e7ea', borderTopWidth: 2, backgroundColor: '#fafbfc' }}>
          {this.renderDays(ratioInfo, true)}
          {this.renderTotalText(ratioTotal, true)}
        </div>
      </div>
    )
  }

  render() {
    return (
      <div
        key='header'
        style={{ display: 'flex', flexDirection: 'column' }}>
        {this.renderDayTotals()}
        {this.renderPayroll()}
        {this.renderRatio()}
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/reports/timeAllocation/TimeAllocationTableSummary.js